/**
 * Единственная точка связи модуля биллинга с приложением Профит.
 * При переносе модуля в общий кабинет меняется только этот файл.
 */
import {http} from "@/api/http";
import {ID_API_URL} from "@/api/base";
import {getUser} from "@/api/user";
import {user} from "@/data/user";
import {subscription} from "@/data/subscription";
import {Message, Messages} from "@/data/messages";
import {PageInfo} from "@/data/page";
import BaseLayout from "@/layouts/Base.vue";
import BaseModal from "@/components/Modal.vue";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import ConfirmModal from "@/components/tools/ConfirmModal.vue";
import {tariffSummary} from "./summary";

export {BILLING_API_URL, BILLING_PRODUCT, billingEnabled} from "./config";

// HTTP-клиент с токеном Kindata ID (Authorization: Bearer) и обновлением токена по 401
export {http, BaseLayout, BaseModal, LoadingBlock, ConfirmModal}

export async function getCompanyId() {
    return await user.getActiveCompany()
}

export async function getUserEmail() {
    try {
        await user.getUserData()
        const result = await getUser(user.user_id)
        return result.data.email || ''
    } catch (e) {
        return ''
    }
}

/**
 * Сохранить ИНН компании в Kindata ID. Некорректный ИНН — 422 со строкой в detail.
 * @returns {Promise<string|null>} сохранённый ИНН
 */
export async function saveCompanyInn(company_id, inn) {
    const result = await http.patch(`${ID_API_URL}/v1/company/${company_id}`, {inn})
    if (user.company_info.id === company_id) {
        user.company_info = {...user.company_info, inn: result.data.inn}
    }
    return result.data.inn
}

// Подписка оплачена или изменена: перечитать тариф в приложении (боковое меню, настройки, лимиты)
export function onSubscriptionChanged() {
    subscription.refresh()
    tariffSummary.load(true)
}

export function notify(text, type = 'success') {
    const message = new Message()
    message.type = type
    message.text = text
    message.autoremove = type === 'success' ? 10 : 0
    Messages.list.push(message)
}

export function setPage(title, parents = []) {
    PageInfo.title = title
    PageInfo.breadcrumbs = [
        {title: 'Главная', link: '/'},
        ...parents,
        {title},
    ]
}
